/**
 * 🎯 Business Domain Utilities
 *
 * 🎯 Business Domain과 관련된 유틸리티 함수들
 */

/**
 * Business Domain을 Firestore 컬렉션 이름으로 변환
 */
export const getCollectionNameFromBusinessDomain = (businessDomain: string): string => {
  const mapping: Record<string, string> = {
    // Entity
    internal_entity: 'internal_entities',
    external_entity: 'external_entities',
    user_entity: 'user_entities',

    // Item
    sellable_item: 'sellable_items',
    service_item: 'service_items',
    asset_item: 'asset_items',
    consumable_item: 'consumable_items',
    raw_material_item: 'raw_material_items',

    // Finance
    finance_state: 'finance_states',
    finance_flow: 'finance_flows',
    finance_budget: 'finance_budgets',
    finance_journal: 'finance_journals',
    legal_entity: 'legal_entities',
    currency_rate: 'currency_rates',
    intercompany: 'intercompany_transactions',

    // Space
    physical_space: 'physical_spaces',
    virtual_space: 'virtual_spaces',

    // Knowledge
    knowledge_report: 'knowledge_reports',
    knowledge_policy: 'knowledge_policies',
    knowledge_plan: 'knowledge_plans',

    // Appeal
    semantic_formation: 'semantic_formations',
    ephemeral_formation: 'ephemeral_formations',
    recurrent_performance: 'recurrent_performances',
    ephemeral_performance: 'ephemeral_performances',

    // Calendar
    calendar_event: 'calendar_events',
    calendar_trigger: 'calendar_triggers',
    calendar_cycle: 'calendar_cycles',
    calendar_anchor: 'calendar_events',

    // Log (Event)
    flow_event: 'flow_events',
    stream_event: 'stream_events',

    // Manufacturing
    manufacturing_bom: 'manufacturing_boms',
    production_order: 'production_orders',
    quality_inspection: 'quality_inspections',
  };

  return mapping[businessDomain] || businessDomain;
};

/**
 * Business Domain을 스키마 문서 ID로 변환
 */
export const getSchemaIdFromBusinessDomain = (businessDomain: string): string => {
  // businessDomain 그대로 사용AME (예: 'internal_entity' -> 'internal_entity')
  return businessDomain;
};

/**
 * Business Domain에서 Entity Type ('internal' | 'external') 추출
 *
 * @param businessDomain 비즈니스 도메인 (예: 'internal_entity', 'external_entity')
 * @returns 'internal' | 'external'
 */
export const getEntityTypeFromBusinessDomain = (
  businessDomain: string
): 'internal' | 'external' => {
  if (businessDomain === 'external_entity') {
    return 'external';
  }
  // 기본값은 'internal' (internal_entity, user_entity 등)
  return 'internal';
};
